import { Box, Typography } from "@mui/material";
import StyledMainButton from "components/buttons/StyledMainButton";
import { Link } from "react-router-dom";
import { useAuth } from "utils/AuthProvider";
import { useAuthMachine } from "auth/state/hook";
import { NEW_CLUSTER } from "utils/routePaths";
import { CustomerEnvironment, OrganizationType } from "utils/saastypes";

export function CreateClusterAction({
  clusters,
  messageId = "cluster-capacity-header",
}: {
  clusters?: CustomerEnvironment[];
  messageId?: string;
}) {
  const { authService } = useAuth();
  const [
    {
      currentOrganization,
      loggedWithNoOrganization,
      isOrkesUser,
      organizationType,
      braavosSubscription,
    },
  ] = useAuthMachine(authService);
  if (loggedWithNoOrganization || !currentOrganization) return null;

  // Count the full organization listing, irrespective of search and filters.
  // Match ClusterService.filterActiveClusters for the states that consume capacity.
  const activeCount = clusters?.filter(
    ({ state }) => state !== "DELETED" && state !== "DELETING"
  ).length;
  const quota = braavosSubscription?.maxQuota;
  const unavailable =
    activeCount == null || quota == null || !Number.isFinite(quota);
  const exhausted = !unavailable && activeCount! >= quota!;
  const trial = organizationType === OrganizationType.FREE_TRIAL;
  const disabled = !isOrkesUser && (unavailable || exhausted || trial);
  const reason = disabled
    ? unavailable
      ? "Cluster capacity could not be verified. Contact Orkes if the issue persists."
      : trial
      ? "Contact your account team to add more clusters to your trial."
      : "Your cluster capacity is fully used. Contact your account team to add more clusters."
    : undefined;

  return (
    <Box>
      <StyledMainButton
        fullWidth
        component={disabled ? "button" : Link}
        {...(!disabled ? { to: NEW_CLUSTER } : {})}
        sx={{
          "&.Mui-disabled": {
            backgroundColor: "action.disabledBackground",
            color: "action.disabled",
          },
        }}
        disabled={disabled}
        aria-describedby={reason ? messageId : undefined}
      >
        Create New Cluster
      </StyledMainButton>
      {reason && (
        <Typography
          id={messageId}
          variant="body2"
          color="text.secondary"
          mt={1}
        >
          {reason}
        </Typography>
      )}
    </Box>
  );
}
